$(function () {
    var swiper = new Swiper(".swiper", {
      slidesPerView: "auto",
      grabCursor: true,
      speed: 1000,
      autoplay: {
        delay: 4000,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
    });
});
